<template>
  <div class="dialog_warp">
    <div class="dialog_form">
      <div class="g-thing-tit flex-box">
        <div class="g-widths">
          <h4 class="">{{info.fileSendName}}</h4>
          <div class="flex-box">
            <p>发起人：{{info.fileSendPublishUnit}}</p>
            <p>发起时间：{{info.fileSendCreateTime|datetimeType("yyyy-MM-dd hh:mm")}}</p>
          </div>
        </div>
        <el-tag>{{info.fileSendTypeName}}</el-tag>
      </div>
      <p class="g-contp" v-html="info.fileSendContent">
      </p>
    </div>
    <div class="text-center">
      <p style="margin-top: 10px;">
        <el-button size="small" class="f-search-btn g-success" type="success" @click.stop="close()">确认
        </el-button>

      </p>
    </div>
  </div>
</template>

<script>
  import * as global from '../config/mUtils'
  import * as getData from "../service/getData";
  export default {
    data() {
      return {
        info: {},
        fileList: [],
        submitLoading: false,
        conts: '',
      }
    },
    created() {
    },
    mounted() {
      this.init();
    },
    computed: {},
    props:['fileSendId'],
    methods: {
      close(type) {
        if (type === 1) {
          this.$emit('init')
        } else {
          this.$emit('closeDialog')
        }
      },
      init() {
        getData.getFileDetail({fileSendFileId:this.fileSendId}).then(res => {
          this.parkListLoading = false;
          if (res.data.code == "success") {
            this.info = res.data.data.fileDetail;
          }
        }).catch(_ => {
          console.log(_);
          this.parkListLoading = false;
        });
      },
    },
    components: {},
    watch: {},
  }
</script>
<style lang="scss">
.g-contp{
  img{
    width: fit-content;
    max-width: 100%;
  }
}

</style>
<style scoped lang="scss">
  @import '../assets/css/mixin';


  .g-thing-tit {
    border-bottom: 1px solid #cccccc;

    .g-widths{
      width: calc(100% - 70px);
    }

    h4 {
      @include sc(16px, #333);
      line-height: 40px;
      font-weight: bold;
    }

    p {
      @include sc(12px, #666);
      line-height: 30px;
      margin-right: 20px;
    }
  }

  .g-contp {
    margin-top: 20px;
    line-height: 24px;
    @include sc(13px, #333);
    text-indent: 2em;
  }

  .dialog_form {
    padding: 20px;
  }

  .f-search-btn {
    width: $btnWid;
    border-radius: $radius;
  }


  .g-success {
    background: $button;
    border-color: $button;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/file-details.vue